var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconEmail = function SvgIconEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 3.506H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-12a1 1 0 0 0-1-1Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1 5.506 8.445 5.63a1 1 0 0 0 1.11 0L19 5.506",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgIconEmail as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4IDMuNTA1ODZIMkMxLjQ0NzcyIDMuNTA1ODYgMSAzLjk1MzU3IDEgNC41MDU4NlYxNi41MDU5QzEgMTcuMDU4MSAxLjQ0NzcyIDE3LjUwNTkgMiAxNy41MDU5SDE4QzE4LjU1MjMgMTcuNTA1OSAxOSAxNy4wNTgxIDE5IDE2LjUwNTlWNC41MDU4NkMxOSAzLjk1MzU3IDE4LjU1MjMgMy41MDU4NiAxOCAzLjUwNTg2WiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS4yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEgNS41MDU4Nkw5LjQ0NTMgMTEuMTM2MUM5Ljc4MTIgMTEuMzYgMTAuMjE4OCAxMS4zNiAxMC41NTQ3IDExLjEzNjFMMTkgNS41MDU4NiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS4yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";